document.addEventListener('DOMContentLoaded', function() {
    // Animate SVGs on Scroll

    // Array to store SVG data
    const svgs = [];

    function animateSvgOnScroll(svgClass, pathClass) {
        const svgElements = document.querySelectorAll(`.${svgClass}`);
        const pathElements = document.querySelectorAll(`.${pathClass}`);

        svgElements.forEach((svg, index) => {
            const path = pathElements[index];
            if (!svg || !path) {
                return;
            }

            const pathLength = path.getTotalLength();
            path.style.strokeDasharray = pathLength;
            path.style.strokeDashoffset = pathLength;

            svgs.push({ svg, path, pathLength });
        });
    }

    function onScroll() {
        svgs.forEach(({ svg, path, pathLength }) => {
            const svgRect = svg.getBoundingClientRect();
            const startScroll = window.scrollY + svgRect.top - window.innerHeight;
            const endScroll = window.scrollY + svgRect.bottom - window.innerHeight + 200 + (svgRect.height * 0.2);

            if (window.scrollY > startScroll && window.scrollY <= endScroll) {
                const scrollPercentage = (window.scrollY - startScroll) / (endScroll - startScroll);
                const drawLength = pathLength * scrollPercentage;
                path.style.strokeDashoffset = Math.max(0, pathLength - drawLength);
            } else if (window.scrollY > endScroll) {
                path.style.strokeDashoffset = 0;
            } else {
                path.style.strokeDashoffset = pathLength;
            }
        });
    }

    window.addEventListener('scroll', onScroll);

    // Example usage
    animateSvgOnScroll('animated-drawn-svg', 'animated-drawn-svg-path');

    // Zoom Image on Scroll
    
    let animationCompleted = false;

    function handleScroll() {
        if (animationCompleted) return;
    
        const container = document.querySelector('.homepage-approach-shape-image');
        const zoomImage = document.querySelector('.homepage-approach-shape-image img');
        
        if (!container || !zoomImage) {
            return;
        }
    
        const containerRect = container.getBoundingClientRect();
        const containerTop = containerRect.top;
        const containerBottom = containerRect.bottom;
        const containerHeight = container.offsetHeight;
        const viewportHeight = window.innerHeight;
    
        // Check if the container is in the viewport
        if (containerTop < viewportHeight && containerBottom > 0) {
            // Calculate progress based on the container's position within the viewport
            const containerMiddle = containerTop + containerHeight / 2;
            const viewportMiddle = viewportHeight / 2;
            const progress = (viewportMiddle - containerMiddle) / (viewportHeight / 2);
    
            // Ensure progress is within the range [0, 1]
            const clampedProgress = Math.max(0, Math.min(1, 1 - Math.abs(progress)));
            const width = 200 - 100 * clampedProgress;
            zoomImage.style.width = `${width}vw`;
    
            // Mark animation as completed if the clamped progress is at least 0.9
            if (clampedProgress >= 0.9) {
                animationCompleted = true;
                zoomImage.style.width = '100vw'; // Ensure the final width is set to 100vw
                window.removeEventListener('scroll', handleScrollOnce); // Remove the scroll event listener
            }
        }
    }
    
    // Use a named function expression to allow removal of the event listener
    const handleScrollOnce = function handleScrollOnce() {
        handleScroll();
        if (animationCompleted) {
            window.removeEventListener('scroll', handleScrollOnce);
        }
    };
    
    window.addEventListener('scroll', handleScrollOnce);

    // Function to handle the zoom effect on scroll
    const handleZoomScroll = function() {
        const elements = document.querySelectorAll('.zoom-portfolio-background');
        elements.forEach(element => {
            const rect = element.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            if (rect.top < windowHeight && rect.bottom > 0) {
                // Calculate the progress of the scroll within the section
                const scrollProgress = (windowHeight - rect.top) / (windowHeight + rect.height);
                const clampedProgress = Math.max(0, Math.min(1, scrollProgress));

                // Calculate the zoom level based on the scroll progress
                const zoomLevel = 1 + clampedProgress * 0.2; // Adjust the zoom factor as needed
                const backgroundImage = element.querySelector('.background-image');
                backgroundImage.style.transform = `scale(${zoomLevel})`;
            }
        });
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleZoomScroll);
    handleZoomScroll(); // Initial check in case elements are already in view

    // Typing effect for text elements
    const typeTextElements = document.querySelectorAll('.type-text');
    let currentIndex = 0;

    function typeNextWord() {
        if (currentIndex < typeTextElements.length) {
            if (currentIndex > 0) {
                typeTextElements[currentIndex - 1].style.display = 'none'; // Hide the previous element immediately
            } else if (currentIndex === 0 && typeTextElements.length > 1) {
                typeTextElements[typeTextElements.length - 1].style.display = 'none'; // Hide the last element from the previous loop
            }

            const element = typeTextElements[currentIndex];
            const text = element.textContent;
            element.textContent = '';
            element.style.display = 'inline'; // Show the current element
            let charIndex = 0;

            function typeChar() {
                if (charIndex < text.length) {
                    element.textContent += text.charAt(charIndex);
                    charIndex++;
                    setTimeout(typeChar, 100); // Adjust typing speed here
                } else {
                    currentIndex++;
                    if (currentIndex >= typeTextElements.length) {
                        currentIndex = 0; // Reset to the first word
                    }
                    setTimeout(typeNextWord, 3000); // Delay before typing the next word
                }
            }

            typeChar();
        }
    }

    typeNextWord();

    function toggleVisibility(showClass, hideClass) {
        const showElements = document.querySelectorAll('.' + showClass);
        const hideElements = document.querySelectorAll('.' + hideClass);
        
        showElements.forEach(element => {
            element.classList.remove('hidden');
        });
        
        hideElements.forEach(element => {
            element.classList.add('hidden');
        });
        
        const toggleCircle = document.getElementById('toggle-circle');
        if (window.innerWidth <= 768) { // Mobile breakpoint
            toggleCircle.style.left = (showClass === 'portfolio-featured') ? '7px' : '72px';
        } else {
            toggleCircle.style.left = (showClass === 'portfolio-featured') ? '7px' : '95px';
        }
        
        // Scroll to the top of the page when toggling to the list view
        if (showClass === 'portfolio-list') {
            window.scrollTo(0, 0);
        }
    }

    // Ensure the function is available globally if needed
    window.toggleVisibility = toggleVisibility;

    // Define the URLs for the custom arrow images
    const slickPrevArrowUrl = '/wp-content/themes/masonbuilders/assets/images/slick-arrow-prev.svg';
    const slickNextArrowUrl = '/wp-content/themes/masonbuilders/assets/images/slick-arrow-next.svg';

    // Slick Slider initialization
    jQuery('.slick-slider').slick({
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        draggable: false,
        prevArrow: '<button type="button" class="slick-prev"><img src="' + slickPrevArrowUrl + '" alt="Previous"></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="' + slickNextArrowUrl + '" alt="Next"></button>',
        responsive: [
            {
                breakpoint: 1024, // Tablet breakpoint
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768, // Mobile breakpoint
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // Initialize FooBox
    jQuery('a[data-foobox]').foobox();

    function handleParallaxScroll() {
        const parallaxElements = document.querySelectorAll('.parallax-image > img, .parallax-image .wp-block-media-text__media img');
        parallaxElements.forEach(element => {
            const rect = element.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const offset = (scrollTop - rect.top) * 0.05; // Adjust the parallax speed as needed
            element.style.transform = `translate(-50%, calc(-50% + ${offset}px))`;
        });
    }

    window.addEventListener('scroll', handleParallaxScroll);
    handleParallaxScroll(); // Initial check in case elements are already in view
});
